import React, { useState, useEffect } from "react";
import { Table, Space, Button, message, Divider, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/ReconAndSettlement/actions";
import Uploads from "./Upload";
import Filter from "./Filter";
import moment from "moment";
import DateFilter from "../../../utils/DatePicker";

const columns = [
  { title: "Name", dataIndex: "name" },
  { title: "From Time", dataIndex: "fromTime" },
  { title: "To Time", dataIndex: "toTime" },
  { title: "Duration In Hrs.", dataIndex: "duration" },
];

const DevelopmentTable = () => {
  const dispatch = useDispatch();
  const { fetchReconGCPData, fetchReconData } = useSelector((state) => ({
    fetchReconGCPData: state.reconReducer?.fetchReconGCPData,
    fetchReconData: state.reconReducer?.fetchReconData,
  }));

  const { profileData } = useSelector((state) => {
    return {
      profileData: state.authReducer?.profileData,
    };
  });

  const { getGCPData } = actions;

  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState({
    11: 1,
    fileType: "JSON",
    date: new Date().toISOString(),
  });
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });

  const handleDateChange = (dates) => {
    // console.log(dates , "dates");
    if (dates) {
      setDateRange({ fromDate: dates[0], toDate: dates[1] });
    } else {
      setDateRange([]);
    }
  };

  useEffect(() => {
    // console.log(dateRange, "dateRange");
    if (dateRange.fromDate && dateRange.toDate) {
      const payload = {
        startDate: moment(
          dateRange?.fromDate["$d"] || dateRange?.fromDate["_d"]
        ).format("YYYY-MM-DDTHH:mm:ss%2B05:30"),
        endDate: moment(
          dateRange?.toDate["$d"] || dateRange?.toDate["_d"]
        ).format("YYYY-MM-DDTHH:mm:ss%2B05:30"),
      };

      dispatch(getGCPData(payload));
    }
  }, [dateRange, dispatch, getGCPData]);

  // const handleDownload = async (fileUrl) => {
  //   try {
  //     const response = await fetch(fileUrl);
  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch the file. Status: ${response.status}`);
  //     }

  //     const blob = await response.blob();
  //     if (blob.size === 0) {
  //       throw new Error("Received empty file.");
  //     }

  //     const downloadUrl = window.URL.createObjectURL(blob);
  //     const fileName = fileUrl.split("/").pop() || "downloaded-file.json";
  //     const anchor = document.createElement("a");
  //     anchor.href = downloadUrl;
  //     anchor.download = fileName;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //     window.URL.revokeObjectURL(downloadUrl);
  //   } catch (error) {
  //     console.error("Download failed:", error.message);
  //   }
  // };

  useEffect(() => {
    const fetchedData =
      Array.isArray(fetchReconGCPData?.data) &&
      fetchReconGCPData?.data?.map((item, index) => ({
        fromTime:
          moment(item?.startDate).format("YYYY-MM-DD HH:mm:ss") || "N/A",
        toTime: moment(item?.endDate).format("YYYY-MM-DD HH:mm:ss") || "N/A",
        duration: item?.fileName || "N/A",
        fileUrl: item?.url,
      }));

    const filteredData =
      Array.isArray(fetchedData) &&
      [...fetchedData]
        ?.filter((item) => !String(item?.fileUrl)?.includes("Reversal"))
        .map((item, index) => {
          return {
            name: `Transaction-${index + 1}`,
            ...item,
          };
        });
    setData(filteredData || []);
  }, [fetchReconGCPData?.data]);

  const items = [
    {
      key: "1",
      label: "Table",
      children: (
        <div>
          <h2 className="font-weight-bold mt-3">Request to Download</h2>
          <Filter
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            loading={fetchReconData?.loading}
          />
          <Divider />

          <h2>Download Data</h2>
          <DateFilter
            onDateChange={handleDateChange}
            selectDateRange={setDateRange}
          />

          <Table
            columns={[
              ...columns,
              {
                title: "Actions",
                render: (_, record) => (
                  <Space>
                    <a
                      href={record.fileUrl}
                      style={{ cursor: "pointer" }}
                      className="filter-button"
                    >
                      Download File
                    </a>
                  </Space>
                ),
              },
            ]}
            rowKey={(record) => record?.name}
            dataSource={data}
            pagination={{
              // total: fetchReconGCPData?.data?.pagination?.total || 10,
              // current: fetchReconGCPData?.data?.pagination?.currentPage,
              // pageSize: fetchReconGCPData?.data?.pagination?.itemsPerPage,
              // showSizeChanger: true,
              // showQuickJumper: true,
              // pageSizeOptions: ["5", "10", "20"],
            }}
            loading={fetchReconGCPData?.loading}
          />

          {/* <img src={amit} alt="upload" className="upload-icon align-self-center justify-content-center" /> */}
        </div>
      ),
    },
    {
      key: "2",
      label: "Upload",
      children: (
        <div className="dev-upload">
          <Uploads
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            loading={fetchReconData?.loading}
          />
        </div>
      ),
    },
  ];

  // console.log(profileData, "profileData");

  return (
    <div>
      <Tabs
        style={{
          "--ant-tabs-tab-hover-color": "#2a901b",
          "--ant-tabs-tab-active-color": "#2a901b",
          "--ant-tabs-ink-bar-color": "#2a901b",
        }}
        defaultActiveKey="1"
        // If the user is an internal user, show both the table and upload tabs.
        // Otherwise, only show the table tab.
        items={
          profileData?.internal !== false
            ? items
            : items?.filter((item) => item.key !== "2")
        }
        onChange={(key) => key}
        indicator={{
          size: (origin) => origin - 20,
          align: "center",
        }}
        // style={{
        //   padding: "4px",
        // }}
        type="line"
        animated
      />

      {/* <div>
        <h2 className="font-weight-bold mt-3">Request to Download</h2>
        <Filter selectedFile={selectedFile} setSelectedFile={setSelectedFile} loading={fetchReconData?.loading} />
        <Divider />
  
        <h2>Download Data</h2>
        <DateFilter onDateChange={handleDateChange} selectDateRange={setDateRange} />
  
        <Table
          columns={[
            ...columns,
            {
              title: "Actions",
              render: (_, record) => (
                <Space>
                  <a href={record.fileUrl} style={{ cursor: "pointer" }} className="filter-button">
                    Download File
                  </a>
                </Space>
              ),
            },
          ]}               
          rowKey={(record) => record?.name}
          dataSource={data}
          pagination={{
            total: fetchReconGCPData?.data?.pagination?.total || 10,
            current: fetchReconGCPData?.data?.pagination?.currentPage,
            pageSize: fetchReconGCPData?.data?.pagination?.itemsPerPage,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["5", "10", "20"],
          }}
          loading={fetchReconGCPData?.loading}
        />        
      </div> */}
    </div>
  );
};

export default DevelopmentTable;
